import React, { useState, useEffect } from 'react';

const Toast = ({ message, type = 'info', duration = 3000, actions = null, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Actions varsa otomatik kapanma
    if (actions) return;
    
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        onClose();
      }, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose, actions]);

  const getToastClass = () => {
    switch (type) {
      case 'success':
        return 'toast-success';
      case 'error':
        return 'toast-error';
      case 'warning':
        return 'toast-warning';
      case 'info':
      default:
        return 'toast-info';
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'bx-check-circle';
      case 'error':
        return 'bx-x-circle';
      case 'warning':
        return 'bx-error-circle';
      case 'info':
      default:
        return 'bx-info-circle';
    }
  };

  return (
    <div 
      className={`toast ${getToastClass()} ${isVisible ? 'toast-visible' : 'toast-hidden'}`}
    >
      <div className="toast-content">
        <div className="toast-icon">
          <i className={`bx ${getIcon()}`}></i>
        </div>
        <div className="toast-message">
          {message}
        </div>
        {!actions && (
          <button 
            className="toast-close"
            onClick={() => {
              setIsVisible(false);
              setTimeout(() => onClose(), 300);
            }}
          >
            <i className="bx bx-x"></i>
          </button>
        )}
      </div>
      {actions && (
        <div className="toast-actions">
          {actions.map((action, index) => (
            <button
              key={index}
              className={`toast-action-btn ${action.label.includes('Sil') ? 'toast-action-danger' : 'toast-action-primary'}`}
              onClick={() => {
                action.onClick();
                setIsVisible(false);
                setTimeout(() => onClose(), 300);
              }}
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
      <div className="toast-progress">
        <div className="toast-progress-bar"></div>
      </div>
    </div>
  );
};

export default Toast;
